// extracted by mini-css-extract-plugin
export default {"wizardProduct":"wizardProduct--gt4v6"};